import { parse, format, isValid } from "date-fns";

// Formats we accept from stored birthdate data.
const ACCEPTED_FORMATS = ["M/d/yyyy", "MM/dd/yyyy", "M-d-yyyy", "MM-dd-yyyy", "yyyy-MM-dd"];

// Shown for missing, incomplete, impossible, or unrecognized dates.
export const BIRTHDATE_FALLBACK = "Needs updated";

/**
 * Safely format a stored birthdate string for display.
 * Accepts M/d/yyyy, MM/dd/yyyy, M-d-yyyy, MM-dd-yyyy, yyyy-MM-dd.
 * Returns the date as "M/d/yyyy" when valid, otherwise "Needs updated".
 * Never throws — an invalid value can never crash the caller.
 */
export function formatBirthdate(value) {
  if (value === null || value === undefined) return BIRTHDATE_FALLBACK;
  const str = String(value).trim();
  if (!str) return BIRTHDATE_FALLBACK;

  const reference = new Date();
  for (const fmt of ACCEPTED_FORMATS) {
    const parsed = parse(str, fmt, reference);
    // isValid rejects unparseable dates; the round-trip rejects impossible /
    // rolled-over / incomplete values (e.g. 02/30/2020, 13/40/2020, "2020").
    if (isValid(parsed) && format(parsed, fmt) === str) {
      return format(parsed, "M/d/yyyy");
    }
  }
  return BIRTHDATE_FALLBACK;
}

export default formatBirthdate;
